/** The texts of quick tagging on the images page (IMG-03, ANN-20), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const quickTagEn = {
  quickTag: 'Quick tag',
  quickTagOnHint: 'Tag the selected images with number keys, in your own annotations',
  quickTagTarget: 'Tag',
  quickTagStudies: 'Studies',
  quickTagStudiesHint: 'Every view of the selected studies, also those this filter leaves out',
  quickTagImages: 'Images',
  quickTagImagesHint: 'Only the selected images',
  selectImage: 'Select {image}',
  imagesSelected: '{count} images selected',
  imagesSelected_one: '1 image selected',
  quickTagViews: '{count} images',
  quickTagViews_one: '1 image',
  quickTagIdle: 'Select images to tag',
  quickTagKeyHint: 'Key {key}; Shift+{key} removes it',
  quickTagFind: 'Find a tag',
  quickTagFindHelp: 'Type a tag, or a tag and its value such as “region carpals”, move with ↑ ↓ and press Enter.',
  quickTagFindCount: '{count} tags',
  quickTagFindCount_one: '1 tag',
  quickTagValueOf: 'Value of {attribute}',
  quickTagKeys: 'Keys',
  quickTagKeysTitle: 'Quick tag keys',
  quickTagKeysHelp:
    'Each number key sets its tag, or a value of it, in your own annotations of the selected images; again, it changes nothing. Shift with the key removes that tag or value. The keys work while the images have the focus, and are kept in this browser.',
  quickTagChooseKey: 'Choose',
  quickTagChooseFor: 'Tag for key {key}',
  quickTagClearKey: 'Clear',
  quickTagResetKeys: 'Default keys',
  quickTagSaving: '{tag}: saving…',
  quickTagSaved: '{tag} set on {count} images',
  quickTagSaved_one: '{tag} set on 1 image',
  quickTagRemoved: '{tag} removed from {count} images',
  quickTagRemoved_one: '{tag} removed from 1 image',
  quickTagUndone: 'Undone on {count} images: {tag}',
  quickTagUndone_one: 'Undone on 1 image: {tag}',
  quickTagRedone: 'Redone on {count} images: {tag}',
  quickTagRedone_one: 'Redone on 1 image: {tag}',
  quickTagUnchanged: '{count} already so',
  quickTagConflicts: '{count} changed elsewhere since, left as they are',
  quickTagRefused: '{count} you may only view',
  quickTagLeft: '{count} no longer match',
  quickTagLeft_one: '1 no longer matches',
  quickTagSelectFirst: 'Select images first',
  quickTagUnbound: 'Key {key} has no tag: choose one under Keys',
  quickTagTooMany: 'At most 500 images at once',
  quickTagNothingToUndo: 'Nothing to undo',
  quickTagNothingToRedo: 'Nothing to redo',
  quickTagFailed: 'Not saved: {error}',
  quickTagRetry: 'Retry',
}

export const quickTagDe: Record<keyof typeof quickTagEn, string> = {
  quickTag: 'Schnell taggen',
  quickTagOnHint: 'Ausgewählte Bilder mit Zifferntasten taggen, in Ihren eigenen Annotationen',
  quickTagTarget: 'Taggen',
  quickTagStudies: 'Studien',
  quickTagStudiesHint: 'Jede Ansicht der ausgewählten Studien, auch die von diesem Filter ausgelassenen',
  quickTagImages: 'Bilder',
  quickTagImagesHint: 'Nur die ausgewählten Bilder',
  selectImage: '{image} auswählen',
  imagesSelected: '{count} Bilder ausgewählt',
  imagesSelected_one: '1 Bild ausgewählt',
  quickTagViews: '{count} Bilder',
  quickTagViews_one: '1 Bild',
  quickTagIdle: 'Bilder zum Taggen auswählen',
  quickTagKeyHint: 'Taste {key}; Umschalt+{key} entfernt ihn',
  quickTagFind: 'Tag suchen',
  quickTagFindHelp: 'Tippen Sie einen Tag oder einen Tag mit Wert wie „region carpals“, wählen Sie mit ↑ ↓ und drücken Sie Enter.',
  quickTagFindCount: '{count} Tags',
  quickTagFindCount_one: '1 Tag',
  quickTagValueOf: 'Wert von {attribute}',
  quickTagKeys: 'Tasten',
  quickTagKeysTitle: 'Tasten zum schnellen Taggen',
  quickTagKeysHelp:
    'Jede Zifferntaste setzt ihren Tag oder einen Wert davon in Ihren eigenen Annotationen der ausgewählten Bilder; erneut gedrückt ändert sie nichts. Mit Umschalt entfernt die Taste diesen Tag oder Wert. Die Tasten wirken, solange die Bilder den Fokus haben, und bleiben in diesem Browser gespeichert.',
  quickTagChooseKey: 'Wählen',
  quickTagChooseFor: 'Tag für Taste {key}',
  quickTagClearKey: 'Leeren',
  quickTagResetKeys: 'Standardtasten',
  quickTagSaving: '{tag}: wird gespeichert…',
  quickTagSaved: '{tag} auf {count} Bildern gesetzt',
  quickTagSaved_one: '{tag} auf 1 Bild gesetzt',
  quickTagRemoved: '{tag} von {count} Bildern entfernt',
  quickTagRemoved_one: '{tag} von 1 Bild entfernt',
  quickTagUndone: 'Auf {count} Bildern rückgängig gemacht: {tag}',
  quickTagUndone_one: 'Auf 1 Bild rückgängig gemacht: {tag}',
  quickTagRedone: 'Auf {count} Bildern wiederholt: {tag}',
  quickTagRedone_one: 'Auf 1 Bild wiederholt: {tag}',
  quickTagUnchanged: '{count} schon so',
  quickTagConflicts: '{count} inzwischen anderswo geändert, unverändert gelassen',
  quickTagRefused: '{count} dürfen Sie nur ansehen',
  quickTagLeft: '{count} passen nicht mehr',
  quickTagLeft_one: '1 passt nicht mehr',
  quickTagSelectFirst: 'Wählen Sie zuerst Bilder aus',
  quickTagUnbound: 'Taste {key} hat keinen Tag: wählen Sie einen unter Tasten',
  quickTagTooMany: 'Höchstens 500 Bilder auf einmal',
  quickTagNothingToUndo: 'Nichts rückgängig zu machen',
  quickTagNothingToRedo: 'Nichts zu wiederholen',
  quickTagFailed: 'Nicht gespeichert: {error}',
  quickTagRetry: 'Erneut versuchen',
}
